import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import PayPage from "@/pages/pay/page";
import SuccessPage from "@/pages/success/page";
import AdminPage from "@/pages/admin/page";
import NotFound from "@/pages/NotFound";
import WechatCallbackPage from "@/pages/wechat-callback/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/pay",
    element: <PayPage />,
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/wechat-callback",
    element: <WechatCallbackPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;